import { Injectable } from '@angular/core';
import { ActivityRegistryService } from '@core/services/api/http/activityRegistry.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  UpdateAddressInformation,
  UpdateDeviceInformation,
  UpdateIsModalOpen,
  UpdateOffersInformation,
  UpdateServiceInformation,
  UpdateStepInformation,
} from './activity-registry.actions';
import { concatMap, debounceTime, distinctUntilChanged, switchMap, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getActivityRegisterData } from './activity-registry.selectors';

@Injectable()
export class ActivityRegistryEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly activityRegistryService: ActivityRegistryService
  ) {}

  updateActivityRegistry$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          ...[
            UpdateDeviceInformation,
            UpdateStepInformation,
            UpdateServiceInformation,
            UpdateOffersInformation,
            UpdateAddressInformation,
            UpdateIsModalOpen,
          ]
        ),
        concatMap(() => this.store.select(getActivityRegisterData).pipe(take(1))),
        distinctUntilChanged((prev, curr) => {
          // Check if the data is the same before resending it, except for the requestTime
          // TODO: Check why this effect is called so many times from the JWT interceptor
          const prevClean = { ...prev, data: { ...prev.data, serviceInfo: { ...prev.data.serviceInfo } } };
          const currClean = { ...curr, data: { ...curr.data, serviceInfo: { ...curr.data.serviceInfo } } };

          delete prevClean.data.serviceInfo.requestTime;
          delete currClean.data.serviceInfo.requestTime;

          return JSON.stringify(prevClean) === JSON.stringify(currClean);
        }),
        debounceTime(1000),
        switchMap(state => {
          return this.activityRegistryService.postInsert(state);
        })
      ),
    { dispatch: false }
  );
}
